export const environment = {
  production: false,
  pre: false,
  qa: true,

  allowedParentOriginOTP: '$(allowedParentOriginOTP)',
  companyContactEmail: 'was.support@tagheuer.com',

  apiClient: 'https://clients.tagqa.ri.dentsutracking.com/qa',
  mfaClient: 'https://auth.tagqa.ri.dentsutracking.com/qa',

  awsMapApiKey: 'v1.public.eyJqdGkiOiI1MzFhYTFjNC1lMDQxLTRhM2MtYWUzNy04NDUzNjVhMjYyOGQifXkUvuVXbK211mLYJlDKc56t0nsSiq_leBY7KnCUSJt7IZW_hM7J-FRsGlI8_lpLv6jfb1wqo58iuo7B794yFa_B4Bmxe1uXoHCFAjKHHtSi-k2zul-6dBvM6Vy7-UnMOPAnz7Gnpx4i2Vkg2nfMekCjYKdhvpbVPVNjqrz7b57f_ZBODy82a0Ohdbu0WTkyVKHFxfLDo1dt0qFtTRK1vzjzbBBYbPG7XHUe1uek-bdpHnd7nLmHRgRLXfGZupWcK7ghRRyGsPBDvuyqvLZXGUJ7mXoK9EZGOnvbniAZ3kD0Y4acxUvUWM79CG5D7jQUua6ZuURVyjZLz8BnT9NNRcg.ZGQzZDY2OGQtMWQxMy00ZTEwLWIyZGUtOGVjYzUzMjU3OGE4',
  awsRegion: 'eu-west-1',

  dynamsoft: {
    productKey: 'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTAwNTAzMjkzLXIxNzM5Mjg3NDYwIiwibWFpblNlcnZlclVSTCI6Imh0dHBzOi8vbWx0cy5keW5hbXNvZnQuY29tLyIsIm9yZ2FuaXphdGlvbklEIjoiMTAwNTAzMjkzIiwic3RhbmRieVNlcnZlclVSTCI6Imh0dHBzOi8vc2x0cy5keW5hbXNvZnQuY29tLyIsImNoZWNrQ29kZSI6NjU1OTIyODg3fQ=='
  }
};
